import {AxiosError} from 'axios';
import {
  GET_NON_NATIONAL_EXAM_WITHDRAWAL_ACKNOWLEDGEMENT_QUERY_KEY
} from '../../constants/queryKeys';
import axiosClient from '../axiosClient';
import {useCustomQuery} from '../utils/useCustomQuery';
import {GET_NON_NATIONAL_EXAM_WITHDRAWAL_ACKNOWLEDGEMENT_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface WithdrawalAcknowledgementResponse {
  applicationId: string;
  localDateTime: string;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (data: WithdrawalAcknowledgementResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalExamWithdrawalAcknowledgement = ({
                                                                 uuid,
                                                                 onSuccess,
                                                                 onError,
                                                               }: Input) => {
  const getNonNationalExamWithdrawalAcknowledgement = async () => {
    const res = await axiosClient.get<WithdrawalAcknowledgementResponse>(
        GET_NON_NATIONAL_EXAM_WITHDRAWAL_ACKNOWLEDGEMENT_URL(uuid)
    );
    return res.data;
  };

  return useCustomQuery(
      GET_NON_NATIONAL_EXAM_WITHDRAWAL_ACKNOWLEDGEMENT_QUERY_KEY,
      getNonNationalExamWithdrawalAcknowledgement,
      {
        onSuccess,
        onError,
      }
  );
};
